import { render, staticRenderFns } from "./WebappDesigner.vue?vue&type=template&id=124a4078&scoped=true&"
import script from "./WebappDesigner.vue?vue&type=script&lang=js&"
export * from "./WebappDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebappDesigner.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WebappDesigner.vue?vue&type=style&index=1&id=124a4078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a4078",
  null
  
)

export default component.exports